import { ILead } from 'src/interfaces/lead';
import { TMailBody, TMailFactory } from '../factories/types';
import { createLeadQuoteMail, magGroupFactory } from '../factories';
import { TServiceClientVehicle } from 'src/interfaces/serviceClient';

const factories: Record<string, TMailFactory> = {
    'mag-group': magGroupFactory,
};

export const getMailBody = (lead: ILead, vehicle: TServiceClientVehicle | null, client: string): TMailBody => {
    const factory = factories[client] || createLeadQuoteMail;
    return factory(lead, vehicle);
};
